import { Link } from 'react-router-dom';
import { formatNewsDate, newsArticles } from '../content/news';

export function News() {
  return (
    <section className="section">
      <div className="container">
        <div className="section-head section-head-news reveal">
          <p className="eyebrow">News</p>
          <h1>Product updates and company milestones.</h1>
          <p>Follow our latest launches, partnership announcements, and platform progress.</p>
        </div>

        {newsArticles.length === 0 && (
          <div className="news-empty reveal reveal-delay-1">
            <h3>No updates yet</h3>
            <p>We have not published any news articles yet. Check back soon for product updates and milestones.</p>
          </div>
        )}

        {newsArticles.length > 0 && (
          <div className="news-list-grid reveal reveal-delay-1">
            {newsArticles.map((n) => (
              <article key={n.id} className="news-card">
                <p className="news-date">{formatNewsDate(n.date)}</p>
                <h3>
                  <Link to={`/news/${encodeURIComponent(n.id)}`}>{n.title}</Link>
                </h3>
                {n.summary ? <p>{n.summary}</p> : <p>Read the full update for details.</p>}
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}


